import { DimensionUnit } from '../../../enums/dimension-unit';

export const dimensionUnitEnumFromOrdinal = (ordinalValue) => {
  const defaultEnum = DimensionUnit.Inches;

  const potentialEnums = Object.values(DimensionUnit).reduce((acc, dimensionsUnit, index) => {
    if (index === ordinalValue) {
      acc.push(dimensionsUnit);
    }
    return acc;
  }, []);

  return potentialEnums.length === 0 ? defaultEnum : potentialEnums.shift();
};
